// src/services/statsApi.js
import axios from 'axios';
import { getJwtToken } from '../utils/auth';
import { getBaseUrl } from '../utils/apiClient';

const statsClient = axios.create({
    baseURL: `${getBaseUrl()}/admin/stats`,
});

statsClient.interceptors.request.use(async (config) => {
    const token = await getJwtToken();
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
}, (error) => Promise.reject(error));

export const getOverview = async (range = '30d') => {
    const res = await statsClient.get('/overview', { params: { range } });
    return res.data;
};

export const getProvidersTimeline = async (range = '90d', groupBy = 'week') => {
    const res = await statsClient.get('/providers/timeline', { params: { range, groupBy } });
    return res.data;
};

export const getReviewsTimeline = async (range = '90d', groupBy = 'week') => {
    const res = await statsClient.get('/reviews/timeline', { params: { range, groupBy } });
    return res.data;
};

export const getUsersTimeline = async (range = '90d', groupBy = 'week') => {
    const res = await statsClient.get('/users/timeline', { params: { range, groupBy } });
    return res.data;
};

export const getTopCategories = async (limit = 10) => {
    const res = await statsClient.get('/categories/top', { params: { limit } });
    return res.data;
};

export const getTopProvidersByEngagement = async (limit = 10) => {
    const res = await statsClient.get('/providers/top-engagement', { params: { limit } });
    return res.data;
};

export const getLocationsCoverage = async () => {
    const res = await statsClient.get('/locations/coverage');
    return res.data;
};

export const getCatalogHealth = async () => {
    const res = await statsClient.get('/catalog-health');
    return res.data;
};
